<div class="flex-row flex">
    <div class="flex">
        <mat-tab-group
            [selectedIndex]="currentTabIndex"
            (selectedIndexChange)="tabIndexChanged($event)"
            mat-stretch-tabs="false"
        >
            <mat-tab label="Specification Template">
                <ng-template [matTabContent]>
                    @if (template) {
                        <div class="cb-padding flex-row flex">
                            <div class="scrollable-container cb-padding-right flex">
                                <mat-card
                                    class="cb-margin-bottom-2x cb-no-padding cb-padding-top cb-padding-right"
                                    style="text-align: right"
                                >
                                    <mat-card-content>
                                        <button
                                            class="cb-margin-right-2x"
                                            mat-raised-button
                                            color="primary"
                                            [disabled]="!canEdit()"
                                            [matMenuTriggerFor]="addItemmenu"
                                        >
                                            Add Item
                                        </button>
                                        <mat-menu #addItemmenu="matMenu" xPosition="before">
                                            <button mat-menu-item (click)="addLotSpecItemClicked()">
                                                Lot Spec Item
                                            </button>
                                            <button mat-menu-item (click)="addColourItemClicked()">
                                                Colour Item
                                            </button>
                                        </mat-menu>
                                        <button
                                            mat-raised-button
                                            class="cb-margin-bottom"
                                            (click)="expandOrCollapseAll()"
                                        >
                                            @if (!isAllExpanded()) {
                                                <span>Expand All&nbsp;</span>
                                            }
                                            @if (isAllExpanded()) {
                                                <span>Collapse All&nbsp;</span>
                                            }
                                            @if (!isAllExpanded()) {
                                                <mat-icon>keyboard_arrow_down</mat-icon>
                                            }
                                            @if (isAllExpanded()) {
                                                <mat-icon>keyboard_arrow_up</mat-icon>
                                            }
                                        </button>
                                    </mat-card-content>
                                </mat-card>
                                @for (houseArea of houseAreas; track houseArea) {
                                    <mat-expansion-panel
                                        class="panel cb-margin-bottom"
                                        [(expanded)]="expansionPanelStates[houseArea.id]"
                                    >
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <span class="cb-margin-left-2x">
                                                    {{ houseArea.houseArea.label }}
                                                    ({{
                                                        houseArea.items
                                                            ? houseArea.items.length
                                                            : 0
                                                    }})
                                                </span>
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>
                                        <div class="cb-margin-bottom-2x" style="text-align: right">
                                            <button
                                                mat-raised-button
                                                color="primary"
                                                [disabled]="!canEdit()"
                                                [matMenuTriggerFor]="addItemmenu"
                                            >
                                                Add Item
                                            </button>
                                            <mat-menu #addItemmenu="matMenu" xPosition="before">
                                                <button
                                                    mat-menu-item
                                                    (click)="addLotSpecItemClicked(houseArea)"
                                                >
                                                    Lot Spec Item
                                                </button>
                                                <button
                                                    mat-menu-item
                                                    (click)="addColourItemClicked(houseArea)"
                                                >
                                                    Colour Item
                                                </button>
                                            </mat-menu>
                                        </div>
                                        <cb-table [loaded]="true">
                                            <thead cbTableHead>
                                                <td></td>
                                                <td>Cost Type</td>
                                                <td>Code</td>
                                                <td>Product</td>
                                                <td>Options</td>
                                                <td>Quantity</td>
                                                <td>Amount</td>
                                                <td>Supplier</td>
                                                <td></td>
                                            </thead>
                                            <tbody cbTableBody>
                                                @for (item of houseArea.items; track item) {
                                                    <tr cbTableRow>
                                                        <td style="color: grey">
                                                            @switch (!item.colourItem) {
                                                                @case (true) {
                                                                    <span>
                                                                        @if (isBundle(item)) {
                                                                            <mat-icon>
                                                                                folder</mat-icon
                                                                            >
                                                                        }
                                                                        @if (item.bundleId) {
                                                                            <mat-icon>
                                                                                attach_file</mat-icon
                                                                            >
                                                                        }
                                                                        @if (item.hasImage) {
                                                                            <mat-icon>
                                                                                photo</mat-icon
                                                                            >
                                                                        }
                                                                        @if (
                                                                            item.showInClientSpecification ||
                                                                            item.inSpec
                                                                        ) {
                                                                            <mat-icon>
                                                                                style</mat-icon
                                                                            >
                                                                        }
                                                                        @if (
                                                                            item.showInColourYourDreams
                                                                        ) {
                                                                            <mat-icon
                                                                                title="Included in Colour Schedule"
                                                                            >
                                                                                import_contacts</mat-icon
                                                                            >
                                                                        }
                                                                        @if (
                                                                            isDescriptiveOnly(
                                                                                item.costType
                                                                            )
                                                                        ) {
                                                                            <mat-icon>
                                                                                notes</mat-icon
                                                                            >
                                                                        }
                                                                    </span>
                                                                }
                                                                @default {
                                                                    <span>
                                                                        <mat-icon
                                                                            >format_paint</mat-icon
                                                                        >
                                                                        @if (
                                                                            item.colourItem.image
                                                                        ) {
                                                                            <mat-icon>
                                                                                photo</mat-icon
                                                                            >
                                                                        }
                                                                    </span>
                                                                }
                                                            }
                                                        </td>
                                                        <td>
                                                            @switch (!item.colourItem) {
                                                                @case (true) {
                                                                    <span>
                                                                        {{
                                                                            item.costType
                                                                                ? COST_TYPE_ENUM[
                                                                                      item.costType
                                                                                  ]
                                                                                : ''
                                                                        }}</span
                                                                    >
                                                                }
                                                                @default {
                                                                    <span>Colour</span>
                                                                }
                                                            }
                                                        </td>
                                                        <td>
                                                            @switch (!item.colourItem) {
                                                                @case (true) {
                                                                    <span>{{
                                                                        item.product
                                                                            ? item.product.code
                                                                            : ''
                                                                    }}</span>
                                                                }
                                                                @default {
                                                                    <span>{{
                                                                        item.colourItem.code
                                                                    }}</span>
                                                                }
                                                            }
                                                        </td>
                                                        <td class="truncate-td">
                                                            @switch (!item.colourItem) {
                                                                @case (true) {
                                                                    <span>{{
                                                                        item.product
                                                                            ? item.product.name
                                                                            : item.productOther
                                                                    }}</span>
                                                                }
                                                                @default {
                                                                    <span>{{
                                                                        item.colourItem.name
                                                                    }}</span>
                                                                }
                                                            }
                                                        </td>
                                                        <td>
                                                            @switch (!item.colourItem) {
                                                                @case (true) {
                                                                    <span>
                                                                        <ul class="inline-list">
                                                                            @for (
                                                                                option of item.options;
                                                                                track option
                                                                            ) {
                                                                                <li>
                                                                                    {{
                                                                                        option.name
                                                                                    }}
                                                                                </li>
                                                                            }
                                                                        </ul>
                                                                    </span>
                                                                }
                                                                @default {
                                                                    <span></span>
                                                                }
                                                            }
                                                        </td>
                                                        <td>
                                                            @switch (!item.colourItem) {
                                                                @case (true) {
                                                                    <span>
                                                                        {{
                                                                            !isDescriptiveOnly(
                                                                                item.costType
                                                                            ) &&
                                                                            !isProvisional(
                                                                                item.costType
                                                                            )
                                                                                ? item.quantity
                                                                                : '-'
                                                                        }}</span
                                                                    >
                                                                }
                                                                @default {
                                                                    <span>-</span>
                                                                }
                                                            }
                                                        </td>
                                                        <td>
                                                            @switch (!item.colourItem) {
                                                                @case (true) {
                                                                    <span>
                                                                        @if (
                                                                            isEstimate(
                                                                                item.costType
                                                                            )
                                                                        ) {
                                                                            <span>
                                                                                {{
                                                                                    item.rateSnapshot
                                                                                        | currency
                                                                                }}</span
                                                                            >
                                                                        }
                                                                        @if (
                                                                            isProvisional(
                                                                                item.costType
                                                                            )
                                                                        ) {
                                                                            <span>
                                                                                {{
                                                                                    item.rateSnapshot
                                                                                }}</span
                                                                            >
                                                                        }
                                                                        @if (
                                                                            !isProvisional(
                                                                                item.costType
                                                                            ) &&
                                                                            !isEstimate(
                                                                                item.costType
                                                                            )
                                                                        ) {
                                                                            <span>-</span>
                                                                        }
                                                                    </span>
                                                                }
                                                                @default {
                                                                    <span>-</span>
                                                                }
                                                            }
                                                        </td>
                                                        <td>
                                                            @switch (!item.colourItem) {
                                                                @case (true) {
                                                                    <span>{{
                                                                        item.supplier &&
                                                                        item.supplier.tradingName
                                                                            ? item.supplier
                                                                                  .tradingName
                                                                            : '-'
                                                                    }}</span>
                                                                }
                                                                @default {
                                                                    <span>-</span>
                                                                }
                                                            }
                                                        </td>
                                                        <td cbTableStickyCol="end" cbTableShrinkCol>
                                                            <button
                                                                mat-icon-button
                                                                [matMenuTriggerFor]="addItemmenu"
                                                            >
                                                                <mat-icon>more_horiz</mat-icon>
                                                            </button>
                                                            <mat-menu
                                                                #addItemmenu="matMenu"
                                                                xPosition="before"
                                                            >
                                                                <button
                                                                    mat-menu-item
                                                                    [disabled]="!canEdit()"
                                                                    (click)="
                                                                        editItemClicked(
                                                                            item,
                                                                            houseArea.houseArea.id
                                                                        )
                                                                    "
                                                                >
                                                                    <mat-icon
                                                                        class="cb-margin-right-3x"
                                                                        >mode_edit</mat-icon
                                                                    >
                                                                    Edit Item
                                                                </button>
                                                                <button
                                                                    mat-menu-item
                                                                    [disabled]="!canEdit()"
                                                                    (click)="
                                                                        removeItemClicked(item)
                                                                    "
                                                                >
                                                                    <mat-icon
                                                                        class="cb-margin-right-3x"
                                                                        >remove_circle</mat-icon
                                                                    >
                                                                    Remove Item
                                                                </button>
                                                                @if (item.offeringId) {
                                                                    <button
                                                                        mat-menu-item
                                                                        (click)="
                                                                            viewItemClicked(item)
                                                                        "
                                                                    >
                                                                        <mat-icon
                                                                            class="cb-margin-right-3x"
                                                                            >pageview</mat-icon
                                                                        >
                                                                        View Item
                                                                    </button>
                                                                }
                                                            </mat-menu>
                                                        </td>
                                                    </tr>
                                                }
                                                @if (!houseArea.items || !houseArea.items.length) {
                                                    <tr cbTableRow>
                                                        <td colspan="9">
                                                            <mat-icon class="mat-accent"
                                                                >info</mat-icon
                                                            >
                                                            &nbsp;
                                                            <span class="mat-body-2">
                                                                There are no Items in this House
                                                                Area</span
                                                            >
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </cb-table>
                                    </mat-expansion-panel>
                                }
                                @if (!houseAreas.length) {
                                    <mat-card>
                                        <mat-card-content
                                            >There are no items to display</mat-card-content
                                        >
                                    </mat-card>
                                }
                            </div>
                        </div>
                    }
                </ng-template>
            </mat-tab>
            <mat-tab label="History">
                <ng-template [matTabContent]>
                    <cb-history-list
                        [entityId]="templateId"
                        [entity]="HISTORY_SEARCH_ENTITY.SpecTemplate"
                    >
                    </cb-history-list>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
    @if (template) {
        <cb-spec-template-side-panel
            class="cb-margin"
            [template]="template"
            [canEdit]="canEdit()"
            [refresh$]="refresh$"
        >
        </cb-spec-template-side-panel>
    }
</div>
